import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { ConnectedAccountCharge } from './connected-account.charge.entity';
import { ConnectedAccountChargeStatus } from './connected-account.charge.status.enum';

export class CreateConnectedAccountChargeDto extends Omit(
    ConnectedAccountCharge,
    [...BaseEntityFieldsArray, 'providerType', 'providerId', 'status'],
    ['status'],
) {
    status?: ConnectedAccountChargeStatus;
}
